// Espaces insécables françaises pour les textes venus de la base (articles du
// blog), à l'affichage (S1, point 8, validé le 20/10). Les textes du code sont
// déjà écrits avec \u00A0 (règle de lint kadelio/insecables).
// Selon la langue : hors français, pas d'espace avant la ponctuation (consigne
// du Pôle traducteurs) ; on retire donc celle qu'un texte français y aurait.

const NBSP = '\u00A0';
const SPACE = '[ \u00A0\u202F]';

export function typoFr(text: string, lang = 'fr'): string {
  if (!text) return text;
  if (!/^fr\b/i.test(lang)) return text.replace(new RegExp(`(\\S)${SPACE}+(?=[?!;:](?:$|\\s))`, 'gu'), '$1');
  return text
    // avant ? ! ; : (fin de mot), et avant »
    .replace(/(?<=[\p{L}\p{N})»’'"…*.]) (?=[?!;:](?:$|[\s)»"'’.,]))/gu, NBSP)
    .replace(/(?<=\S) (?=»)/gu, NBSP)
    // après «
    .replace(/(?<=«) (?=\S)/gu, NBSP)
    // nombre et unité : 12 €, 3,5 %, 5 min, 3 h
    .replace(/(?<=\d) (?=(?:€|%|min\b|h\b))/gu, NBSP)
    // signe moins d'un montant : « - 17,50 € »
    .replace(/(?<=^|\s)([-−]) (?=\d)/gu, `$1${NBSP}`);
}
